/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { SearchInstructions200ResponseData } from './SearchInstructions200ResponseData'
import {
  SearchInstructions200ResponseDataFromJSON,
  SearchInstructions200ResponseDataFromJSONTyped,
  SearchInstructions200ResponseDataToJSON,
} from './SearchInstructions200ResponseData'

/**
 *
 * @export
 * @interface SearchInstructions200Response
 */
export interface SearchInstructions200Response {
  /**
   *
   * @type {boolean}
   * @memberof SearchInstructions200Response
   */
  status: boolean
  /**
   *
   * @type {SearchInstructions200ResponseData}
   * @memberof SearchInstructions200Response
   */
  data: SearchInstructions200ResponseData
}

/**
 * Check if a given object implements the SearchInstructions200Response interface.
 */
export function instanceOfSearchInstructions200Response(
  value: object
): value is SearchInstructions200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function SearchInstructions200ResponseFromJSON(
  json: any
): SearchInstructions200Response {
  return SearchInstructions200ResponseFromJSONTyped(json, false)
}

export function SearchInstructions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SearchInstructions200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: SearchInstructions200ResponseDataFromJSON(json['data']),
  }
}

export function SearchInstructions200ResponseToJSON(
  value?: SearchInstructions200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: SearchInstructions200ResponseDataToJSON(value['data']),
  }
}
